import {
  Backdrop,
  Box,
  CircularProgress,
  createTheme,
  IconButton,
  ThemeProvider,
  Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useContext, useMemo, useState } from "react";
import { Link as RouterLink, useNavigate, } from "react-router-dom";
import { valueTagsList } from "../../data/valueTagData";
import CustomTheme from "../../theme/customTheme";
import ComponentBackdrop from "../../components/backdrop";
import { DataContext } from "./index";
import dayjs from "dayjs";
import { Edit } from "@mui/icons-material";
import CustomToolbar from "../../utils/customToolbar";

const Listing = ({ currentPage, totalPage, pageSize, handleShowButton }) => {
  const rows = useContext(DataContext);
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const onSelectedCheckbox = (id, rows) => {
    let selectedIds = [];

    if (id.type === "include") {
      selectedIds = Array.from(id.ids);
    } else if (id.type === "exclude") {
      const excluded = new Set(id.ids);
      selectedIds = rows
        .filter((row) => !excluded.has(row.id))
        .map((row) => row.id);
    }
    console.log("selectCheckBox:", selectedIds);
    handleShowButton(selectedIds);
  };

  const navigate = useNavigate();
  
    const navigateDetails = (id) => {
      navigate(`/edit-valuetag/${id}`);
    }

  const columns = [
    {
      field: "Actions",
      headerName: "Action",
      width: 100,
      type: "actions",
      hideable: false,
      getActions: (params) => [
        <IconButton
          sx={{ color: "#39493F" }}
          onClick={() => navigateDetails(params.row.id)} // 👈 navigate with row id
        >
          <Tooltip title="Edit" placement="right">
            <Edit />
          </Tooltip>
        </IconButton>,

        // <IconButton sx={{ color: "#39493F" }}>
        //   <Tooltip title="Delete" placement="right">
        //     <Delete />
        //   </Tooltip>
        // </IconButton>,
      ],
    },
    {
      field: "id",
      headerName: "ID",
      width: 80,
     
    },
    {
      field: "code",
      headerName: "Group",
      width: 150,
      flex: 1,
    },
    {
      field: "startDate",
      headerName: "Start Date",
      minWidth: 150,
      type: "date",
      // Always return a Date object here
      valueGetter: (params) => {
        const value = params;
        return value ? dayjs(value).toDate() : null;

      },
      // Format it for display
      valueFormatter: (params) => {
        if (!(params instanceof Date) || isNaN(params)) return "";
        return dayjs(params).format("DD-MM-YYYY");
      },
    },
    {
      field: "endDate",
      headerName: "End Date",
      minWidth: 150,
      type: "date",
      valueGetter: (params) => {
        const value = params;
        return value ? dayjs(value).toDate() : null;

      },
      // Format it for display
      valueFormatter: (params) => {
        if (!(params instanceof Date) || isNaN(params)) return "";
        return dayjs(params).format("DD-MM-YYYY");
      },
    },
  ];
  return (
     <Box
        style={{
          width: "100%",
          height: "77vh",
          overflowY: rows.length > 10 ? "auto" : "visible", // scroll if too many
        }}
      >
      <ComponentBackdrop open={open} close={handleClose} />

      {/* <ThemeProvider theme={CustomTheme}> */}
      <DataGrid
        columns={columns}
        rows={rows}
        showToolbar
         slots={{ toolbar: CustomToolbar }}
        pageSizeOptions={[50, 100, { value: 500, label: "500" }]}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 50 },
          },
          sorting: {
            sortModel: [{field : "endDate", sort: 'desc'}],
          },
          columns: {
              columnVisibilityModel: {
                id: false, // hide ID column by default
              },
            },
        }}
        slotProps={{
           toolbar: {
            title: ""
           },
          loadingOverlay: {
            variant: "linear-progress",
            noRowsVariant: "skeleton",
          },
          disableToolbarButton: {
            csvOptions: "true",
            printOptions: "true",
          },
          toolbar: {
            printOptions: { disableToolbarButton: true },
            csvOptions: { disableToolbarButton: true }
          },
        }}
        checkboxSelection
        onRowSelectionModelChange={(id) => {
          onSelectedCheckbox(id, rows);
        }}
        disableRowSelectionOnClick
        localeText={{ noRowsLabel: "No records found" }}
      />
      {/* </ThemeProvider> */}
    </Box>
  );
};

export default Listing;
